import React, { Component } from 'react';
import styles from './FloatingInfoBarStyles';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { getElementStageLayout } from '../MouseCatcherUtils';
import { connect } from 'react-redux';
import { getSelectedElementsWithDragPosition, isMultiSelect } from 'crazyEditor/redux/modules/element/elementSelectors';
import { elementTypes } from 'crazyEditor/components/Elements/index';
const unSupportedElements = [
  elementTypes.PageElement,
  elementTypes.BackgroundElement
];
const classes = require('shared/styles/common.scss');

@connect(
  state => ({
    selectedElements: getSelectedElementsWithDragPosition(state),
    isMultiSelect: isMultiSelect(state),
  })
)
export default class FloatingInfoBar extends Component {
  render() {
    const { selectedElements, isMultiSelect, isDraggingElement, isResizingElement } = this.props;
    const selectedElement = selectedElements[0];
    if (isMultiSelect || unSupportedElements.indexOf(selectedElement.type) !== -1) {
      return null;
    }

    const elementLayout = selectedElement.layout;

    return (
      <div className={classes.noSelect} style={{...getElementStageLayout(selectedElement), ...styles.infoBarWrapper}}>
        {isDraggingElement &&
        <span>
          <span style={styles.infoBarItem}>
            <span style={styles.infoBarItemLabel}>X:</span>
            <span style={styles.infoBarItemValue}>{Math.round(elementLayout.x)}</span>
          </span>
          <span style={{...styles.infoBarItem, paddingRight: 0}}>
            <span style={styles.infoBarItemLabel}>Y:</span>
            <span style={styles.infoBarItemValue}>{Math.round(elementLayout.y)}</span>
          </span>
        </span>
        }
        {isResizingElement &&
        <span>
          <span style={styles.infoBarItem}>
            <span style={styles.infoBarItemLabel}>W:</span>
            <span style={styles.infoBarItemValue}>{elementLayout.width}</span>
          </span>
          <span style={{...styles.infoBarItem, paddingRight: 0}}>
            <span style={styles.infoBarItemLabel}>H:</span>
            <span style={styles.infoBarItemValue}>{elementLayout.height}</span>
          </span>
        </span>
        }
      </div>
    );
  }
}